import React from 'react'
import { Typography } from '@mui/material'
import PropTypes from 'prop-types'
import Badge from './Badge'
import { MESSAGES } from '../messages/messages'

const AccordionContent = ({
    text,
    index,
    axzPlanPrice = false,
    axzPrice = [],
    badge = [],
    badgeContent = [],
    bold = [],
    mandatory = false
}) => {
    return (
        <Typography
            tabIndex={0}
            variant={bold[index] ? 'semiBoldBody2' : 'regularBody2'}
            color={bold[index] ? 'text.primary' : 'text.secondary'}
            sx={{
                flex: index === 0 ? { xs: 1.3, md: 1.5, lg: 1.7 } : 1,
                letterSpacing: bold[index] ? '1px' : '0px',
                textAlign: index === 0 ? 'left' : 'right',
                textWrap: 'balance'
            }}
        >
            {axzPlanPrice ? (
                <Typography
                    variant="regularBody3"
                    sx={{
                        fontWeight: 500
                    }}
                >
                    * {text}
                    {badge?.[index] && (
                        <Typography component="span">
                            <Badge badgeContent={badgeContent[index]}></Badge>
                        </Typography>
                    )}
                    <Typography
                        component="span"
                        variant="regularBody3"
                        sx={{
                            fontWeight: 500,
                            marginLeft: '16px'
                        }}
                    >
                        {MESSAGES.of + ' ' + axzPrice[index] + ' ' + MESSAGES.additional_fees}
                    </Typography>
                </Typography>
            ) : (
                <>
                    {text}
                    {badge?.[index] && (
                        <Typography component="span">
                            <Badge badgeContent={badgeContent[index]}></Badge>
                        </Typography>
                    )}
                    {mandatory && index ? <>*</> : ''}
                </>
            )}
        </Typography>
    )
}

AccordionContent.propTypes = {
    text: PropTypes.string,
    index: PropTypes.number,
    axzPlanPrice: PropTypes.bool,
    axzPrice: PropTypes.array,
    badge: PropTypes.array,
    badgeContent: PropTypes.array,
    bold: PropTypes.array,
    mandatory: PropTypes.bool
}

export default AccordionContent
